import { Component, OnInit , EventEmitter, HostListener} from '@angular/core';
import { ApiRequestService } from '../../../_services/api-request.service';
import { MaterializeAction } from 'angular2-materialize';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { saveAs } from 'file-saver';

declare var $:any;
declare var Materialize:any;

@Component({
  selector: 'app-workscom',
  templateUrl: './workscom.component.html',
  styleUrls: ['./workscom.component.css']
})
export class WorkscomComponent implements OnInit {

 
  imrdetail;
  loads=1;
  
  
  list_causes_symptoms;
  causes_loader = 0;
  list_causes_symptoms_loader = 0;

  list_symptoms;
  symptoms_loader = 0;


  
  phase_1_loader = 0;

  phase_1a_loader = 0;
  list_d;
  list_d_loader = 0;
  d_name;
  ; 
 
  phase_2_loader = 0;
  treatment_data;

 
  clinical_summary_loader = 0;
  

  
  divcode;
  tags;
  tag_id;
  which_vise;
  label_chart;

  

  Selections_Record;


  

  casedata = 0;

 

  html: SafeHtml;

// New UseCase Flow

  stepper = 0;
  bodypart = "Choose Your Option";
  bodypartlist;
  
  getlistloader = 0;
  diseases_loader = 0;
  getdrugs_loader = 0;
  drug_loader = 0;

  disease_name;
  causes_name;
  diagnosis_name;
  symptom_name;
  treatment_name;
  drug_name;

  list_diseases;
  list_causes;
  list_diagnosis;
  list_symptom;
  list_treatments;
  list_drugs;

  DiseasesArray = [];
  CausesArray = [];
  DiagnosisArray = [];
  SymptomsArray = [];
  TreatmentArray = [];
  DrugsArray = [];

  CausesCheckbox = [];
  DiagnosisCheckbox = [];
  SymptomsCheckbox = [];
  DiseasesCheckbox = [];
  TreatmentCheckbox = [];
  DrugsCheckbox = [];

  clinical_summary;
  dataid = 0;
  summary_keys;


  constructor(private apirequest: ApiRequestService,private sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.getList();
    $("#Case_Vise").removeClass("active");
    $('#Body_Parts_Vise').addClass("active");
    setTimeout(() => {
      this.modal_tab('Body_Parts_Vise');
    }, 1000);
  }

  getList(){
    this.getlistloader = 1;
    let input = {
      action:"get_body_parts"
    }
    console.log(input);
    
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);  

      if(res.status == 'True') {        
        console.log(res.msg);
        this.bodypartlist = res.msg;
        this.getlistloader = 0;
      } else {
        this.msg_view(res.msg);
        this.getlistloader = 0;
      }
      
      
    });
  }

  getDiseases(){
    this.reset_code();
    this.getlistloader = 1;
    let input = {
      action:"get_diseases",
      body_part: this.bodypart
    }
    console.log(input);
    
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);  

      if(res.status == 'True') {  
        this.getlistloader = 0;      
        console.log(res.msg);
        this.list_diseases = res.msg;
        this.stepper = 1;
      } else {
        this.getlistloader = 0;
        this.msg_view(res.msg);
        this.stepper = 0;
      }
      
      
    });
  }

  set_diseases(item,id){
    this.disease_name = item;
    this.Checkbox_Drum('diseases', item, id); 
  }

  getAllData(){
    this.causes_name;
    this.diagnosis_name;
    this.symptom_name;
    this.treatment_name;
    this.drug_name;
  
    this.list_causes;
    this.list_diagnosis;
    this.list_symptom;
    this.list_treatments;
    this.list_drugs;
  
    this.CausesArray = [];
    this.DiagnosisArray = [];
    this.SymptomsArray = [];
    this.TreatmentArray = [];
    this.DrugsArray = [];
  
    this.CausesCheckbox = [];
    this.DiagnosisCheckbox = [];
    this.SymptomsCheckbox = [];
    this.TreatmentCheckbox = [];
    this.DrugsCheckbox = [];
  
    this.clinical_summary;
    this.dataid = 0;
    this.summary_keys; 

    this.diseases_loader = 1;
    let input = {
      action:"get_disease_data",
      diseases: this.DiseasesArray
    }
    console.log(input);
    
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);  

      if(res.status == 'True') {  
        this.diseases_loader = 0;    
        let data = res.msg;
        this.list_causes = data.causes;
        this.list_diagnosis = data.diagnosis;
        this.list_symptom = data.symptoms;
        this.list_treatments = data.treatments;        
        this.stepper = 2;
      } else {
        this.diseases_loader = 0;
        this.msg_view(res.msg);
        this.stepper = 0;
      }
      
      
    });
  }

  set_causes(item,id){
    this.causes_name = item;
    console.log(this.causes_name);
    this.Checkbox_Drum('causes', item, id);
  }

  set_diagnosis(item,id){
    this.diagnosis_name = item;
    console.log(this.diagnosis_name);
    this.Checkbox_Drum('diagnosis', item, id);
  }

  set_symptom(item,id){
    console.log(item);   
    this.symptom_name = item;
    this.Checkbox_Drum('symptoms', item, id);   
  }

  set_treatments(item,id){
    console.log(item);   
    this.treatment_name = item;
    this.Checkbox_Drum('treatments', item, id);  
  }

  set_drugs(item,id){
    console.log(item);   
    this.drug_name = item; 
    this.Checkbox_Drum('drugs', item, id); 
  }

  getdrugs(){
  
    this.clinical_summary;
    this.dataid = 0;
    this.summary_keys; 
    this.getdrugs_loader = 1;
    let input = {
      action:"get_drugs",
      body_part:this.bodypart,
      diseases:this.DiseasesArray,
      causes:this.CausesArray,
      symptoms:this.SymptomsArray,
      treatments:this.TreatmentArray,
      diagnosis:this.DiagnosisArray
      }
    console.log(input);
      
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);  

      if(res.status == 'True') {  
        this.getdrugs_loader = 0;    
        let data = res.msg;
        this.list_drugs = data;
        console.log(this.list_drugs);
            
        this.stepper = 4;
      } else {
        this.getdrugs_loader = 0;
        this.msg_view(res.msg);
        this.stepper = 0;
      }
      
      
    });
    
    
  }

  getsummary(){
    this.clinical_summary = undefined;
    this.dataid = 0;
    this.drug_loader = 1;
    let input = {
      "action":"get_summary",
      "body_part":this.bodypart,
      "diseases":this.DiseasesArray,
      "causes":this.CausesArray,
      "symptoms":this.SymptomsArray,
      "treatments":this.TreatmentArray,
      "diagnosis":this.DiagnosisArray,
      "drugs":this.DrugsArray
      };
      console.log(input);
      
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);
      // res.msg = {Uphold: "the mg twice a day ibuprofen mg once a day and omeprazole the",
      // Uphold2: "mg twice a day ibuprofen mg once a day and omeprazole the",
      // Upholasdd: "mg twice a day ibuprofen mg once a day and omeprazole the",
      // Upholasdd2: "mg twice a day ibuprofen mg once a day and omeprazole the",}
      this.summary_keys = Object.keys(res.msg);
      console.log(this.summary_keys);  

      if(res.status == 'True') {  
        this.drug_loader = 0;
        if(this.summary_keys.length != 0){
          this.stepper = 4;
          this.clinical_summary = res.msg;
        } else {
          this.msg_view('Empty Response')
        }                
      } else {
        this.drug_loader = 0;
        this.msg_view(res.msg);
        this.stepper = 0;
      }
      
      
    });
  }

  Checkbox_Drum(type,data,id){
    console.log(data);
    console.log(id);
    let checkbox:any = document.getElementById(id);
    if(type === 'causes') {
      if(checkbox.checked == false) {
        const index = this.CausesArray.indexOf(data);
        if (index > -1) {
          this.CausesArray.splice(index, 1);
        }
        console.log(this.CausesArray);

        const index1 = this.CausesCheckbox.indexOf(id);
        if (index1 > -1) {
          this.CausesCheckbox.splice(index1, 1);
        }
        console.log(this.CausesCheckbox);
      } else if(checkbox.checked == true) {
        this.CausesArray.push(data);
        console.log(this.CausesArray);
        this.CausesCheckbox.push(id);
        console.log(this.CausesCheckbox);
      }
    } else if(type === 'symptoms') {
      if(checkbox.checked == false) {
        const index = this.SymptomsArray.indexOf(data);
        if (index > -1) {
          this.SymptomsArray.splice(index, 1);
        }
        console.log(this.SymptomsArray);
        const index1 = this.SymptomsCheckbox.indexOf(id);
        if (index1 > -1) {
          this.SymptomsCheckbox.splice(index1, 1);
        }
        console.log(this.SymptomsCheckbox);
      } else if(checkbox.checked == true) {
        this.SymptomsArray.push(data);
        console.log(this.SymptomsArray);
        this.SymptomsCheckbox.push(id);
        console.log(this.SymptomsCheckbox);
      }

    } else if(type === 'diseases') {
      if(checkbox.checked == false) {
        const index = this.DiseasesArray.indexOf(data);
        if (index > -1) {
          this.DiseasesArray.splice(index, 1);
        }
        console.log(this.DiseasesArray);
        const index1 = this.DiseasesCheckbox.indexOf(id);
        if (index1 > -1) {
          this.DiseasesCheckbox.splice(index1, 1);
        }
        console.log(this.DiseasesCheckbox);
      } else if(checkbox.checked == true) {
        this.DiseasesArray.push(data);
        console.log(this.DiseasesArray);
        this.DiseasesCheckbox.push(id);
        console.log(this.DiseasesCheckbox);
      }

    } else if(type === 'drugs') {
      if(checkbox.checked == false) {
        const index = this.DrugsArray.indexOf(data);
        if (index > -1) {
          this.DrugsArray.splice(index, 1);
        }
        console.log(this.DrugsArray);
        const index1 = this.DrugsCheckbox.indexOf(id);
        if (index1 > -1) {
          this.DrugsCheckbox.splice(index1, 1);
        }
        console.log(this.DrugsCheckbox);
      } else if(checkbox.checked == true) {
        this.DrugsArray.push(data);
        console.log(this.DrugsArray);
        this.DrugsCheckbox.push(id);
        console.log(this.DrugsCheckbox);
      }
    } else if(type === 'diagnosis') {
      if(checkbox.checked == false) {
        const index = this.DiagnosisArray.indexOf(data);
        if (index > -1) {
          this.DiagnosisArray.splice(index, 1);
        }
        console.log(this.DiagnosisArray);
        const index1 = this.DiagnosisCheckbox.indexOf(id);
        if (index1 > -1) {
          this.DiagnosisCheckbox.splice(index1, 1);
        }
        console.log(this.DiagnosisCheckbox);
      } else if(checkbox.checked == true) {
        this.DiagnosisArray.push(data);
        console.log(this.DiagnosisArray);
        this.DiagnosisCheckbox.push(id);
        console.log(this.DrugsCheckbox);
      }
    } else if(type === 'treatments') {
      if(checkbox.checked == false) {
        const index = this.TreatmentArray.indexOf(data);
        if (index > -1) {
          this.TreatmentArray.splice(index, 1);
        }
        console.log(this.TreatmentArray);
        const index1 = this.TreatmentCheckbox.indexOf(id);
        if (index1 > -1) {
          this.TreatmentCheckbox.splice(index1, 1);
        }
        console.log(this.TreatmentCheckbox);
      } else if(checkbox.checked == true) {
        this.TreatmentArray.push(data);
        console.log(this.TreatmentArray);
        this.TreatmentCheckbox.push(id);
        console.log(this.DrugsCheckbox);
      }
    }
    
  }

  reset_code(){
    // this.bodypart = "Choose Your Option";
    this.disease_name = undefined;
    this.causes_name = undefined;
    this.diagnosis_name = undefined;
    this.symptom_name = undefined;
    this.treatment_name = undefined;
    this.drug_name = undefined;
  
    this.list_diseases = undefined;
    this.list_causes = undefined;
    this.list_diagnosis = undefined;
    this.list_symptom = undefined;
    this.list_treatments = undefined;
    this.list_drugs = undefined;
  
    this.DiseasesArray = [];
    this.CausesArray = [];
    this.DiagnosisArray = [];
    this.SymptomsArray = [];
    this.TreatmentArray = [];
    this.DrugsArray = [];
  
    this.CausesCheckbox = [];
    this.DiagnosisCheckbox = [];
    this.SymptomsCheckbox = [];
    this.DiseasesCheckbox = [];
    this.TreatmentCheckbox = [];
    this.DrugsCheckbox = [];
  
    this.clinical_summary = undefined;
    this.dataid = 0;
    this.summary_keys = undefined;  
    this.Selections_Record = undefined;
    this.stepper_id(1);
  }

  reset(){
    this.bodypart = "Choose Your Option";
    this.disease_name = undefined;
    this.causes_name = undefined;
    this.diagnosis_name = undefined;
    this.symptom_name = undefined;
    this.treatment_name = undefined;
    this.drug_name = undefined;
  
    this.list_diseases = undefined;
    this.list_causes = undefined;
    this.list_diagnosis = undefined;
    this.list_symptom = undefined;
    this.list_treatments = undefined;
    this.list_drugs = undefined;
  
    this.DiseasesArray = [];
    this.CausesArray = [];
    this.DiagnosisArray = [];
    this.SymptomsArray = [];
    this.TreatmentArray = [];
    this.DrugsArray = [];
  
    this.CausesCheckbox = [];
    this.DiagnosisCheckbox = [];
    this.SymptomsCheckbox = [];
    this.DiseasesCheckbox = [];
    this.TreatmentCheckbox = [];
    this.DrugsCheckbox = [];
  
    this.clinical_summary = undefined;
    this.dataid = 0;
    this.summary_keys = undefined;  
    this.Selections_Record = undefined;
    this.stepper_id(1);
  }

  stepper_id(id){
    console.log(id);
    var checkerid:any;
    this.stepper = id;    

    if(this.stepper == 2 && this.CausesCheckbox.length != 0){
      console.log(this.CausesCheckbox);      
      setTimeout(() => {
        for (let index = 0; index < this.CausesCheckbox.length; index++) {
          checkerid = document.getElementById(this.CausesCheckbox[index]);
          checkerid.checked = true;
        }  
      }, 100);
    }
    if(this.stepper == 2 && this.SymptomsCheckbox.length != 0){
      console.log(this.SymptomsCheckbox);      
      setTimeout(() => {
        for (let index = 0; index < this.SymptomsCheckbox.length; index++) {
          checkerid = document.getElementById(this.SymptomsCheckbox[index]);
          checkerid.checked = true;
        }  
      }, 100);
    }
    if(this.stepper == 1 && this.DiseasesCheckbox.length != 0){
      console.log(this.DiseasesCheckbox);      
      setTimeout(() => {
        for (let index = 0; index < this.DiseasesCheckbox.length; index++) {
          checkerid = document.getElementById(this.DiseasesCheckbox[index]);
          checkerid.checked = true;
        }  
      }, 100);
    }
    if(this.stepper == 2 && this.DrugsCheckbox.length != 0){
      console.log(this.DrugsCheckbox);      
      setTimeout(() => {
        for (let index = 0; index < this.DrugsCheckbox.length; index++) {
          checkerid = document.getElementById(this.DrugsCheckbox[index]);
          checkerid.checked = true;
        }  
      }, 100);
    }
    if(this.stepper == 2 && this.TreatmentCheckbox.length != 0){
      console.log(this.TreatmentCheckbox);      
      setTimeout(() => {
        for (let index = 0; index < this.TreatmentCheckbox.length; index++) {
          checkerid = document.getElementById(this.TreatmentCheckbox[index]);
          checkerid.checked = true;
        }  
      }, 100);
    }
    if(this.stepper == 2 && this.DiagnosisCheckbox.length != 0){
      console.log(this.DiagnosisCheckbox);      
      setTimeout(() => {
        for (let index = 0; index < this.DiagnosisCheckbox.length; index++) {
          checkerid = document.getElementById(this.DiagnosisCheckbox[index]);
          checkerid.checked = true;
        }  
      }, 100);
    }
  }
  
  Reset_Diseases(){
    for (let index = 0; index < this.DiseasesCheckbox.length; index++) {
      $(document.getElementById(this.DiseasesCheckbox[index])).prop('checked', false);  
    }
    this.DiseasesArray = [];
    this.DiseasesCheckbox = [];
        
   
    this.causes_name = undefined;
    this.diagnosis_name = undefined;
    this.symptom_name = undefined;
    this.treatment_name = undefined;
    this.drug_name = undefined;
  
   
    this.list_causes = undefined;
    this.list_diagnosis = undefined;
    this.list_symptom = undefined;
    this.list_treatments = undefined;
    this.list_drugs = undefined;
  
    
    this.CausesArray = [];
    this.DiagnosisArray = [];
    this.SymptomsArray = [];
    this.TreatmentArray = [];
    this.DrugsArray = [];
  
    this.CausesCheckbox = [];
    this.DiagnosisCheckbox = [];
    this.SymptomsCheckbox = [];
    this.TreatmentCheckbox = [];
    this.DrugsCheckbox = [];
  
    this.clinical_summary = undefined;
    this.dataid = 0;
    this.summary_keys = undefined;  
    this.Selections_Record = undefined;
    
  }
  
  Reset_Causes(){
    for (let index = 0; index < this.CausesCheckbox.length; index++) {
      $(document.getElementById(this.CausesCheckbox[index])).prop('checked', false);  
    }
    this.CausesArray = [];
    this.CausesCheckbox = [];
  }

  Reset_Symptoms(){
    for (let index = 0; index < this.SymptomsCheckbox.length; index++) {
      $(document.getElementById(this.SymptomsCheckbox[index])).prop('checked', false);  
    }
    this.SymptomsArray = [];
    this.SymptomsCheckbox = [];
  }
  
  Reset_Treatments(){
    for (let index = 0; index < this.TreatmentCheckbox.length; index++) {
      $(document.getElementById(this.TreatmentCheckbox[index])).prop('checked', false);  
    }
    this.TreatmentArray = [];
    this.TreatmentCheckbox = [];
  }

  Reset_Diagnosis(){
    for (let index = 0; index < this.DiagnosisCheckbox.length; index++) {
      $(document.getElementById(this.DiagnosisCheckbox[index])).prop('checked', false);  
    }
    this.DiagnosisArray = [];
    this.DiagnosisCheckbox = [];
  }

  SelectCheckboxes(){
    $(function(){
      $("#main-check").click(function () {
            $('.mcheck').prop('checked', this.checked);
      });
   });
  }










// Old UI Flow





  modal_tab(id){
    $(document).ready(function() {
      $(".tab-btn").click(function () {
          $(".tab-btn").removeClass("active");
          $(this).addClass("active");   
      });
    });
    this.which_vise = id;
    console.log(this.which_vise);
    if(this.which_vise === 'Body_Parts_Vise'){
      setTimeout(() => {
        $(document).ready(function(){
          $('.ratio').addClass("show");
        });
      }, 1000);
    } 
    
  }
  msg_view(msg_data) {
    $(document).ready(function() {
      Materialize.toast(msg_data.toString(), 3000, 'grey darken-4');
    });
  }
  phase_1(){
    this.list_causes_symptoms_loader = 1;
    let input = {
      action:"get_causes",
      bodypart:"lumbar_spine",
      disease_name:""
    }
    console.log(input);
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);  

      if(res.status == 'True') {        
        this.list_causes_symptoms_loader = 0;
        this.list_causes_symptoms = res.msg;
        this.stepper = 1;
      } else {
        this.stepper = 0;
        this.list_causes_symptoms_loader = 0;
        this.msg_view(res.msg);
      }
      
      
    });
    
  }
  phase_1b(){
    this.SymptomsArray = [];
    this.SymptomsCheckbox = [];
    this.DiseasesArray = [];
    this.DiseasesCheckbox = [];
    this.DrugsArray = [];
    this.DrugsCheckbox = [];
    this.list_d = undefined;
    this.list_d_loader = 0;
    this.d_name = undefined;
    this.phase_1_loader = 0;
    this.list_drugs = undefined; 
    this.drug_name = undefined;
    this.phase_2_loader = 0;
    this.treatment_data = undefined;
    this.clinical_summary = undefined; 
    this.list_causes_symptoms_loader = 0;
    this.list_symptoms = undefined;
    this.symptoms_loader = 0;
    this.symptom_name = undefined;  
    this.causes_loader = 1;
    let input = {
      action:"get_symptoms_using_causes",
      bodypart:"lumbar_spine",
      causes_name:this.CausesArray
    }
    console.log(input);
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);  

      if(res.status == 'True') {        
        this.causes_loader = 0;
        this.list_symptoms = res.msg;
        this.stepper = 2;
        setTimeout(() => {
          $(document).ready(function(){
            $('.ratio').addClass("show");
          });
        }, 1500);
        this.Selections_Record = true;
      } else {
        this.stepper = 0;
        this.causes_loader = 0;
          this.msg_view(res.msg);
      }
      
      
    });
    
  }
  phase_1a(){
    this.list_drugs = undefined;
    this.treatment_data = undefined;
    this.clinical_summary = undefined; 
    this.d_name = undefined;
    this.list_d = undefined;
    this.DiseasesArray = [];
    this.DiseasesCheckbox = [];
    this.DrugsArray = [];
    this.DrugsCheckbox = [];
    // this.reset();
    this.symptoms_loader = 1;
    let input = {
      action:"get_disease_using_symptom",
      bodypart:"lumbar_spine",
      disease_name:"",
      causes_name:this.CausesArray,
      symptom_name: this.SymptomsArray,
      by_cause:true
    }
    console.log(input);
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res);  

      if(res.status == 'True') {        
        this.symptoms_loader = 0;
        this.list_d = res.msg;
        this.stepper = 3;
        setTimeout(() => {
          $(document).ready(function(){
            $('.ratio').addClass("show");
          });
        }, 1500);
      } else {
        this.stepper = 0;
        this.symptoms_loader = 0;
          this.msg_view(res.msg);
      }
      
      
    });
    
  }
  set_name(item,id){
    // console.log(item);   
    this.d_name = item;
    this.Checkbox_Drum('diseases', item, id);   
  }    
  phase_2(){
    this.DrugsArray = [];
    this.DrugsCheckbox = [];
    this.clinical_summary = undefined;
    this.dataid = 0;
    this.treatment_data=undefined;
    this.list_drugs= undefined; 
    this.phase_1_loader = 1;
    let input = {
      action:"get_drugs_ratio",
      bodypart:"lumbar_spine",
      disease_name:this.DiseasesArray,
      symptom_name: this.SymptomsArray,
      causes_name:this.CausesArray,
      by_cause:true
    }
    console.log(input);
    
    this.apirequest.customize_flow(input).subscribe(res => {
      // console.log(res);  

      if(res.status == 'True') {
        // console.log("done");
        this.stepper = 4;
        this.phase_1_loader = 0;
        this.list_drugs = res.msg;
        // console.log(this.list_drugs);
        // this.phase_3();
        
      } else {
        this.stepper = 0;
        this.phase_1_loader = 0;
          this.msg_view(res.msg);
      }
      
      
    });
  }
  treatment_status;
  phase_3(){
    this.phase_2_loader = 1;
    let input = {
      action:"get_treatments",
      bodypart:"lumbar_spine",
      disease_name:this.DiseasesArray
    }
    console.log(input);
    this.apirequest.customize_flow(input).subscribe(res => {
      // console.log(res);  

      if(res.status == 'True') {
        // console.log("done");
        this.stepper = 5;
        this.phase_2_loader = 0;
        this.treatment_status = res.status;
        this.treatment_data = res.msg;
        // console.log(this.treatment_data);
        
      } else {
        this.treatment_status = res.status;
        this.stepper = 0;
        this.phase_2_loader = 0;
          this.msg_view(res.msg);
      }
      
      
    });
  }
  getClinicalSummary(){
    this.clinical_summary = undefined;
    this.dataid = 0;
    this.clinical_summary_loader = 1;
    let input = {
      action:"get_clinical_summary",
      bodypart:"lumbar_spine",
      symptom_name:this.SymptomsArray,
      disease_name:this.DiseasesArray,
      drug_name:this.DrugsArray,
      causes_name:this.CausesArray
    }
    console.log(input);
    this.apirequest.customize_flow(input).subscribe(res => {
      console.log(res); 
      // res.msg = {Uphold: "the mg twice a day ibuprofen mg once a day and omeprazole the",
      // Uphold2: "mg twice a day ibuprofen mg once a day and omeprazole the",
      // Upholasdd: "mg twice a day ibuprofen mg once a day and omeprazole the",
      // Upholasdd2: "mg twice a day ibuprofen mg once a day and omeprazole the",}
      this.summary_keys = Object.keys(res.msg);
      console.log(this.summary_keys);
       

      if(res.status == 'True') {        
        this.clinical_summary_loader = 0;
        if(this.summary_keys.length != 0){
          this.stepper = 6;
          this.clinical_summary = res.msg;
        } else {
          this.msg_view('Empty Response')
        }
        
      } else {
        this.stepper = 0;
        this.clinical_summary_loader = 0;
          this.msg_view(res.msg);
      }
      
      
    });
  }
  setvalue(id){
    this.dataid = this.dataid + id; 
    console.log(this.dataid);
    
  }
  hover(id){
    $(document).ready(function() {
      $(".imr-content button").click(function () {
          $(".imr-content button").removeClass("active");
          $(this).addClass("active");   
      });
    });

    if(id === 'target_btn'){
      this.tag_id = id;
      setTimeout(() => {
        $(document).ready(function(){
          $('ul.tabs').tabs();
        });
      }, 1000);
      this.tags_call('entity_tags');
    } else {
      this.tag_id = undefined;
      this.tags = undefined;
    }

    // console.log(typeof(this.html));
    // console.log(this.html);
  }
  tags_call(id){
    this.tags = id;
    let input = {
      action:"get_case_detail_tagged",
      case_number:"CM17-0133747",
      flag:id
    }
    console.log(input);
    
    this.apirequest.case(input).subscribe(res => {
      // console.log(res);  
      if(res.status == "True") {
        // this.divcode = '<div class="entities" style="line-height: 2.5; direction: ltr"><mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    maximus    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    federal services    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> sent the complete case file to an <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    expert    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    reviewer    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> the <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    expert    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    reviewer    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> has no <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    affiliation    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> with the <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    employer    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    employee providers    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> or the claims <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    administrator    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> has been in <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    active clinical practice    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> for more than five <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    years    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and is currently <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    working    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> at least hours a <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    week    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> in <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    active practice    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> was selected based on his her <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    clinical    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> experience education background and <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    expertise    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> in the same or similar <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    specialties    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> that <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    evaluate    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and or <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    treat    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> the <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    medical condition    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and disputed <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    items    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    service    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> is familiar with governing <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    laws    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    regulations    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> applied the <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    mtus    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    medical    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> evidence <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    search sequence    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    mtus    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    methodology    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> for <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    evaluating    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    medical    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    evidence    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> where <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    appropriate    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> and has the following <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    credentials state    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> s of <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    licensure california    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    certification    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> s <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    specialty    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    physical medicine    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark> <mark class="entity" style="background: #ddd; padding: 0.45em 0.6em; margin: 0 0.25em; line-height: 1; border-radius: 0.35em;">    rehabilitation    <span style="font-size: 0.8em; font-weight: bold; line-height: 1; border-radius: 0.35em; vertical-align: middle; margin-left: 0.5rem">ENTITY</span></mark></div>';
        // console.log(this.divcode);
        this.divcode = res.msg;
        this.html = this.sanitizer.bypassSecurityTrustHtml(this.divcode);
      } else {
        this.divcode = '<div class="col s12 center red-text"><p>'+res.msg+'</p></div>';
        this.html = this.sanitizer.bypassSecurityTrustHtml(this.divcode);
        this.msg_view(res.msg);
      }
    });
  }
  download_Summary_Report(id){
    console.log(id);

    let text='';

    for (let index = 0; index < this.summary_keys.length; index++) {
      text = text + this.summary_keys[index] + " : " +'\n'+ "=====================" +'\n' + this.clinical_summary[this.summary_keys[index]] + '\n \n';
    }
    console.log(text);
    
    
    if(id === 'summary'){
      let file = new Blob(["CLINICAL SUMMARY ("+this.bodypart+") :" +"\r\n"+"\r\n"+ text], { type: "plain/text;charset=utf-8" });
      saveAs(file, 'CLINICAL_SUMMARY.txt');
    } 
    else {
      let file = new Blob(["CLINICAL SUMMARY REPORT ("+this.bodypart+") :" +"\r\n"+"\r\n"+ text +"\r\n"
      +"\r\n"+'Causes: ' +"\r\n"+ "=====================" +"\r\n" + this.CausesArray +
      "\r\n"+"\r\n"+'Symptoms: ' +"\r\n"+ "=====================" +"\r\n" + this.SymptomsArray+
      "\r\n"+"\r\n"+'Diseases: ' +"\r\n"+ "=====================" +"\r\n" + this.DiseasesArray+
      "\r\n"+"\r\n"+'Diagnosis: ' +"\r\n"+ "=====================" +"\r\n" + this.DiagnosisArray+
      "\r\n"+"\r\n"+'Treatment: ' +"\r\n"+ "=====================" +"\r\n" + this.TreatmentArray+
      "\r\n"+"\r\n"+'Drugs: ' +"\r\n"+ "=====================" +"\r\n" + this.DrugsArray], { type: "plain/text;charset=utf-8" });
      saveAs(file, 'CLINICAL_SUMMARY_REPORT.txt');
    }
  }
  ngOnDestroy(){
    console.log("destroying child...");
    this.list_d = undefined;
    this.list_d_loader = 0;
    this.d_name = undefined;
    this.phase_1_loader = 0;
    this.list_drugs = undefined; 
    this.drug_name = undefined;
    this.phase_2_loader = 0;
    this.treatment_data = undefined;
    this.bodypart = "Choose Your Option";
    this.which_vise = undefined;
    this.clinical_summary = undefined; 
    this.list_causes_symptoms = undefined;
    this.causes_name = undefined;
    this.causes_loader = 0;
    this.list_causes_symptoms_loader = 0;
    this.list_symptoms = undefined;
    this.symptoms_loader = 0;
    this.symptom_name = undefined;
    this.CausesArray = [];
    this.SymptomsArray = [];
    this.DiseasesArray = [];
    this.DrugsArray = [];
    this.CausesCheckbox = [];
    this.SymptomsCheckbox = [];
    this.DiseasesCheckbox = [];
    this.DrugsCheckbox = [];
    this.Selections_Record = undefined;  
  }

}



// WEBPACK FOOTER //
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/components_user/workscom/workscom.component.ts